import React, { useState } from 'react'
import { Image, Linking, StyleSheet, View } from 'react-native'

import Layout from '../../../constants/Layout'
import { CustomText } from '../../text/StyledText'
import { txt } from '../../../locales/i18n'
import NormalIcon from '../../icons/NormalIcon'
import CustomPressable from '../../pressables/CustomPressable'
import Colors from '../../../constants/Colors'
import { ShadowStyles } from '../../../styles'
import { URLOpener } from '../../../utils/URLOpener'
import { CafeMap } from './CafeMap'
import OptionsDialog from '../../dialogs/OptionsDialog'
import BehaviorDialog from './BehaviorDialog'
import { ButtonPrimary } from '../../buttons/StyledButtons'

export default function SproglandInfo({ junior = false }) {
	const [optionsModalVisible, setOptionsModalVisible] = useState(false)
	const [behaviorModalVisible, setBehaviorModalVisible] = useState(false)

	const guideJunior = {
		label: txt(`learnDanish.guide.linkTextJunior`),
		icon: 'info-circle',
		action: async () => {
			await URLOpener(`https://filer.boblberg.dk/Files/Guides/guide_sprogland_junior_dansk.pdf`)
			setOptionsModalVisible(false)
		},
	}

	const guideEnglish = {
		label: txt(`learnDanish.guide.linkTextEnglish`),
		icon: 'info-circle',
		action: async () => {
			await URLOpener(`https://filer.boblberg.dk/Files/Guides/guide_sprogland_english.pdf`)
			setOptionsModalVisible(false)
		},
	}

	const guideDanish = {
		label: txt(`learnDanish.guide.linkTextDanish`),
		icon: 'info-circle',
		action: async () => {
			await URLOpener(`https://filer.boblberg.dk/Files/Guides/guide_sprogland_dansk.pdf`)
			setOptionsModalVisible(false)
		},
	}

	const dictionary = {
		label: txt('learnDanish.volunteer.materials.dictionary'),
		icon: 'book',
		action: async () => {
			await URLOpener('https://filer.boblberg.dk/Files/Sprogland/Ukrainian-Danish-English-dictionary.pdf')
			setOptionsModalVisible(false)
		},
	}

	const behavior = {
		label: txt('learnDanish.help.label'),
		icon: 'shield',
		action: async () => {
			setBehaviorModalVisible(true)
			setOptionsModalVisible(false)
		},
	}

	const options = [
		{
			label: txt('learnDanish.guide.faq'),
			icon: 'question-circle',
			action: async () => {
				await URLOpener(`https://boblberg.dk/sprogland/faq`)
				setOptionsModalVisible(false)
			},
		},
	]

	if (junior) options.push(guideJunior)
	if (junior === false) options.push(guideEnglish, guideDanish)
	options.push(dictionary)
	options.push(behavior)

	return (
		<>
			<View style={!Layout.isSmallDevice && { flexDirection: 'row', justifyContent: 'space-evenly', flex: 4 }}>
				<View style={!Layout.isSmallDevice && { flex: 2 }}>
					<View style={{ margin: 10 }}>
						<CustomText font="bold" style={{ textAlign: 'center' }}>
							{txt('learnDanish.user.help')}
						</CustomText>
						<View style={styles.item}>
							<NormalIcon
								name="envelope"
								size={16}
								stroke="fas"
								style={{ paddingRight: 10 }}
								color={Colors.redCrossRed}
							/>
							<CustomText font="small" style={{ lineHeight: 22, flex: 1, flexWrap: 'wrap' }}>
								{txt('learnDanish.user.helpText')}
								<CustomPressable
									onPress={() =>
										Linking.openURL(junior ? 'mailto:sproglandjunior@rodekors.dk' : 'mailto:sprogland@rodekors.dk')
									}
								>
									<CustomText font="small" style={{ color: Colors.blueAzure }}>
										{junior ? 'sproglandjunior@rodekors.dk' : 'sprogland@rodekors.dk'}
									</CustomText>
								</CustomPressable>
							</CustomText>
						</View>
					</View>
				</View>
				<View style={!Layout.isSmallDevice && { flex: 2 }}>
					<View style={{ margin: 10 }}>
						<CustomText font="bold" style={{ textAlign: 'center' }}>
							{txt('learnDanish.user.reference')}
						</CustomText>
						<View style={styles.item}>
							<Image
								style={{ width: 16, height: 16, marginRight: 10 }}
								resizeMode={'contain'}
								accessibilityIgnoresInvertColors
								source={{ uri: 'https://filer.boblberg.dk/Assets/Img/sprogland/rk-logo.png' }}
								accessible
								accessibilityRole="image"
							/>
							<CustomText font="small" style={{ lineHeight: 22, flex: 1, flexWrap: 'wrap' }}>
								<CustomPressable
									onPress={() => URLOpener('https://www.rodekors.dk/sprogunivers/vidensbank')}
									style={{ display: 'flex' }}
								>
									<CustomText font="small" style={{ color: Colors.blueAzure }}>
										{txt('learnDanish.user.referenceLink1')}
									</CustomText>
								</CustomPressable>
								<CustomPressable
									onPress={() => URLOpener('https://www.rodekors.dk/trivsel')}
									style={{ display: 'flex' }}
								>
									<CustomText font="small" style={{ color: Colors.blueAzure }}>
										{txt('learnDanish.user.referenceLink2')}
									</CustomText>
								</CustomPressable>
								<CustomPressable
									onPress={() => URLOpener('https://www.rodekors.dk/venner-viser-vej')}
									style={{ display: 'flex' }}
								>
									<CustomText font="small" style={{ color: Colors.blueAzure }}>
										{txt('learnDanish.user.referenceLink3')}
									</CustomText>
								</CustomPressable>
							</CustomText>
						</View>
					</View>
				</View>
			</View>

			<CafeMap />

			<ButtonPrimary
				title={txt('learnDanish.guide.supportingMaterials')}
				onPress={() => setOptionsModalVisible(true)}
				titleStyle={{ fontSize: 15, fontFamily: 'raleway-regular' }}
				style={[styles.button, { marginTop: 12 }]}
			/>

			<OptionsDialog
				visible={optionsModalVisible}
				onDismiss={() => setOptionsModalVisible(false)}
				options={options}
				font="smallBold"
			/>

			<BehaviorDialog visible={behaviorModalVisible} close={() => setBehaviorModalVisible(false)} />
		</>
	)
}

const styles = StyleSheet.create({
	item: {
		backgroundColor: Colors.white,
		borderRadius: 2,
		marginTop: 10,
		padding: 10,
		...ShadowStyles.liftedShadow,
		flexDirection: 'row',
		alignItems: 'center',
	},
	button: {
		width: 150,
		paddingHorizontal: 8,
	},
})
